import React from "react";
import {
  banksBSocieties,
  clientDetails,
  creditCards,
  General,
  healthAssurance,
  homePersonal,
  incomeProtection,
  Investments,
  lifeAssurance,
  loansLeaseHP,
  Mortages,
  pensions,
  savingsPlans,
  Shares,
  unitLinked,
} from "../../shared/actionlistDetails";
import { formatedDate, getClientType, getYes_NoConversion } from "../../utils";
import ReactQuillComponent from "../../components/ReactQuillComponent";

interface ActionListItemDetailsProps {
  activeRowItem: any;
  activeRowItemDetail: any;
}
const renderClientType = (type: number) => (type ? getClientType(type) : "-");
const renderDate = (date: string) => (date ? formatedDate(date) : "-");
const renderRichText = (text: string) =>
  text ? <ReactQuillComponent value={text} width="100%" /> : <div>-</div>;
const renderYesorNo = (value: number) =>
  value ? getYes_NoConversion(value) : "-";

const ActionListDetails: React.FC<ActionListItemDetailsProps> = ({
  activeRowItem,
  activeRowItemDetail,
}) => {
  const renderFieldValue = (field: string, data: any) => {
    switch (field) {
      case "policy_holder":
      case "joint_indicator":
        return renderClientType(data[field]);
      case "mortgage_link":
        return renderYesorNo(data[field]);
      case "start_date":
      case "end_date":
      case "status_date":
      case "valuation_date":
      case "value_date":
      case "bank_date_opened":
      case "home_date_acquired":
      case "share_date_acquired":
      case "amount_outstanding_date":
        return renderDate(data[field]);
      case "provider_note":
      case "benefit_text":
      case "in_trust_note":
      case "admin_note":
      case "report_note":
      case "withdrawal_note":
      case "note_text":
        return renderRichText(data[field]);
      default:
        return data[field] || "-";
    }
  };

  const renderPolicyDetails = (policyData: any[]) => (
    <div>
      {policyData.map((item: any) => (
        <div key={item.id} className="details">
          <p className="details_label">{item.label}</p>
          <p>{renderFieldValue(item.value, activeRowItemDetail)}</p>
        </div>
      ))}
    </div>
  );

  const renderClientDetails = () => (
    <div>
      {Object.keys(activeRowItemDetail).length !== 0 &&
        clientDetails.length > 0 &&
        clientDetails.map((clientDetail: any) => (
          <div key={clientDetail.client_id} className="details">
            <p className="details_label">{clientDetail.label}</p>
            <p>
              {clientDetail.value === "date_of_birth"
                ? activeRowItemDetail?.date_of_birth
                  ? renderDate(activeRowItemDetail.date_of_birth)
                  : ""
                : clientDetail.value === "review_note"
                  ? renderRichText(activeRowItem?.description)
                  : activeRowItemDetail && activeRowItemDetail.NameAndAddress
                    ? activeRowItemDetail?.NameAndAddress[clientDetail.value] ||
                      activeRowItemDetail?.Contact[clientDetail.value] ||
                      activeRowItemDetail?.Nationality[clientDetail.value] ||
                      activeRowItemDetail?.Personal[clientDetail.value] ||
                      "-"
                    : "-"}
            </p>
          </div>
        ))}
    </div>
  );

  if (
    activeRowItem?.category === "Policy Review Date" ||
    (activeRowItem?.business_category === 1 &&
      activeRowItem?.category === "Case Tracking Action")
  ) {
    switch (activeRowItem?.case_type) {
      case "Life Assurance":
        return renderPolicyDetails(lifeAssurance);
      case "Pensions":
        return renderPolicyDetails(pensions);
      case "Savings Plans":
        return renderPolicyDetails(savingsPlans);
      case "Income Protection":
        return renderPolicyDetails(incomeProtection);
      case "Health Assurance":
        return renderPolicyDetails(healthAssurance);
      case "General":
        return renderPolicyDetails(General);
      case "Investments":
        return renderPolicyDetails(Investments);
      default:
        return null;
    }
  } else if (
    activeRowItem?.case_type === "Unit-linked" ||
    (activeRowItem?.business_category === 2 &&
      activeRowItem?.category === "Case Tracking Action") ||
    activeRowItem?.category === "Asset(Investment) Review"
  ) {
    return renderPolicyDetails(unitLinked);
  } else if (
    activeRowItem?.case_type === "Shares" ||
    activeRowItem?.category === "Asset(Shares) Review"
  ) {
    return renderPolicyDetails(Shares);
  } else if (
    activeRowItem?.case_type === "Banks/B Societies" ||
    activeRowItem?.category === "Asset(Banks) Review"
  ) {
    return renderPolicyDetails(banksBSocieties);
  } else if (
    activeRowItem?.case_type === "Home/Personal" ||
    activeRowItem?.category === "Asset(Home) Review"
  ) {
    return renderPolicyDetails(homePersonal);
  } else if (
    activeRowItem?.case_type === "Mortgages" ||
    (activeRowItem?.business_category === 6 &&
      activeRowItem?.category === "Case Tracking Action") ||
    activeRowItem?.category === "Mortgage Review Date"
  ) {
    return renderPolicyDetails(Mortages);
  } else if (
    activeRowItem?.case_type === "Loans/Lease/HP" ||
    (activeRowItem?.business_category === 7 &&
      activeRowItem?.category === "Case Tracking Action") ||
    activeRowItem?.category === "Loan Review Date"
  ) {
    return renderPolicyDetails(loansLeaseHP);
  } else if (
    activeRowItem?.case_type === "Credit Cards" ||
    activeRowItem?.category === "Credit Card Review Date"
  ) {
    return renderPolicyDetails(creditCards);
  } else if (
    activeRowItem?.category === "Client Review" ||
    activeRowItem?.category === "Client Action" ||
    activeRowItem?.category === "Birthday"
  ) {
    return renderClientDetails();
  } else {
    return null;
  }
};

export default ActionListDetails;
